import React, {useEffect, useState} from 'react'
import {getClients} from '../../../../components/requests'
import {ModeleSavClient} from '../../../../components/sav/Models'
import {nomSavClient} from '../../../../components/sav/libelles'

type Props = {
  onChoix: (client: ModeleSavClient) => void
  onCreer: () => void
}

// Recherche d'un client par la recherche client existante (nom, mail, téléphone, code client)
const SavClientRecherche = ({onChoix, onCreer}: Props) => {
  const [recherche, setRecherche] = useState('')
  const [resultats, setResultats] = useState<Array<ModeleSavClient>>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (recherche.trim().length < 2) {
      setResultats([])
      return
    }
    const minuterie = setTimeout(() => {
      setLoading(true)
      getClients(1, recherche.trim(), '', '')
        // L'API client renvoie chaque ligne sous la forme {0: client, ...colonnes calculées}
        .then((reponse) =>
          setResultats((reponse?.data ?? []).map((ligne: any) => ligne?.[0] ?? ligne))
        )
        .finally(() => setLoading(false))
    }, 350)
    return () => clearTimeout(minuterie)
  }, [recherche])

  return (
    <div>
      <div className='d-flex justify-content-end mb-2'>
        <button type='button' className='btn btn-link p-0 fw-bold text-success' onClick={onCreer}>
          + Client inconnu : créer le client
        </button>
      </div>
      <input
        className='form-control form-control-solid'
        placeholder='Rechercher un client (nom, mail, téléphone, code client)'
        value={recherche}
        onChange={(e) => setRecherche(e.target.value)}
      />
      {loading && <div className='text-muted mt-2'>Recherche…</div>}
      {resultats.length > 0 && (
        <div className='list-group mt-2' style={{maxHeight: 260, overflowY: 'auto'}}>
          {resultats.map((client) => (
            <button
              type='button'
              key={client.id}
              className='list-group-item list-group-item-action d-flex justify-content-between'
              onClick={() => {
                onChoix(client)
                setRecherche('')
                setResultats([])
              }}
            >
              <span className='fw-bold text-uppercase'>{nomSavClient(client)}</span>
              <span className='text-muted fs-7'>
                {client.generique && (
                  <span className='badge badge-light-warning me-2'>Générique</span>
                )}
                {client.email ?? client.telephone ?? ''}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default SavClientRecherche
